import React, {Fragment } from 'react'
import { Button, Card } from '../../components'
import { useHistory } from "react-router-dom"
import { ReactComponent as BackButton } from '../../assets/icons/ui/BackButton.svg'

const OutageWarning = () =>{
  const history = useHistory()
  const handleClick = () =>{
    history.push("/OutageWarning/OutageMap")
  }
  return (
    <Fragment>
      <div className="report-outage">
        <section className="report-outage__main-wires-down main">
                 
          <h1 className="report-outage__title">
                        Report a Street Light Outage
          </h1>
                   
          <Card className="report-outage__wires-down-instruction">
            <div className="report-outage__alert-message">
              <div className="report-outage__alert-message-content">
                <h3>Stop!</h3>
                <h4>A damaged street light can be dangerous.</h4>
                <h5>Please contact us to report an emergency at <a href="tel:+18006424272">800 642 4272</a></h5>
              </div>

            </div>
            <h6>Exposed street light wires or components should be treated as live electric,
                         Stay clear until the area is made safe.</h6>
            <div className="wires-down-content"> 
              <div className="wires-down-content__do">
                <h3>Do:</h3>
                <ul>
                  <li>Keep children and pets away from the damaged street light.</li>
                  <li>Keep your distance from any exposed wire, line may be energized and deadly.</li>
                  <li>Stay where you are, including inside your vehicle and report the problem.</li>
                </ul>
              </div>
              <div className="wires-down-content__dont">
                <h3>Don't:</h3>
                <ul>
                  <li>Don’t touch the down pole or exposed wire with your hand or any object – including sticks, brooms, or poles.</li>
                  <li>Don’t touch anything in contact with an exposed street light wire, including cars, equipment, objects or other people.</li>
                  <li>Don’t drive in the exposed or compromised area of the street light.</li>
                                    
                </ul>
              </div>
            </div>
                                        
          </Card>
          <div className="report-outage__actions">
            
            <Button
              className={`-primary`}
              aria-label={`Continue to report streelight outage`}
              data-a11y-focus="first"
              onClick={handleClick}
            >
                        Continue Reporting Outage
            </Button>
            <Button
              className={`-secondary warningCancel`}
              aria-label={`Cancel and return to National Grid Streetlights outage homepage`}
              data-a11y-focus="first"
              onClick={() => history.push('/')}
            >
                        Cancel
            </Button>
            <Button
              className={`button -link-button-back -secondary back`}
              aria-label={`Back`}
              data-a11y-focus="first"
              onClick={() => history.push("/")}
            >
              <BackButton/>
            </Button>
          </div>
        </section>
      </div>
    </Fragment>
  )

}

export default OutageWarning
